// src/components/Navbar.js
import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {  Menu, MenuItem, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
const Navbar = () => {
//   const { user, logout } = useContext(AuthContext);
const [anchorEl, setAnchorEl] = React.useState(null);
const Navigate=useNavigate()
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
   Navigate('/');

  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Student Dashboard
        </Typography>
        <Typography variant="body1" sx={{ mr: 2 }}>
          {/* {user?.name} */} trtrtrtrtrtrtArif
        </Typography>
        <div>
          <IconButton onClick={handleMenu} color="inherit">
            <Avatar alt="User" src="/static/images/avatar/1.jpg" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>
      </Toolbar>

    </AppBar>
  );
};

export default Navbar;
